.mainPaper {
	max-width: 1400px;
}

.customCheckStyle {
	font-size: 50px !important;
	color: var(--green) !important;
}

.marginTop {
	margin-top: 5px !important;
}

.marginTopBold {
	margin-top: 5px !important;
	font-weight: bold !important;
}

.leftMargin {
	margin-left: 200px !important;
}

.marginTopFifty {
	margin-top: 50px !important;
}

.tableMinWidth {
	min-width: 900px !important;
	max-width: 900px !important;
}

.bold {
	font-weight: bold !important;
}

.tableBackground {
	background-color: var(--title-background) !important;
}

.customErrorStyle {
	font-size: 50px !important;
	color: var(--rx-primary-red) !important;
}

.marginTopError {
	margin-top: 6px !important;
	color: var(--rx-primary-red) !important;
}

.buttonMarginTop {
	margin-top: 30px !important;
}

.descriptionMarginTop {
	margin-top: 100px !important;
}
